import './index.css'
import type { AnnualChartProps } from '../../types'

const PL = 8, PR = 8, PT = 14, PB = 28, CH = 140

export default function AnnualChart({ months }: AnnualChartProps) {
  const values = months.flatMap(m => [m.income, m.expense])
  const max = values.length > 0 ? Math.max(...values) || 1 : 1
  const n   = months.length
  const gap = 60
  const W   = PL + Math.max(0, n - 1) * gap + PR
  const H   = PT + CH + PB

  const xOf = (i: number) => PL + i * gap
  const yOf = (v: number) => PT + (1 - v / max) * CH

  const line = (key: 'income' | 'expense') =>
    months.map((m, i) => `${xOf(i)},${yOf(m[key])}`).join(' ')

  return (
    <div className="bc-card bc-annual">
      <div className="bc-list__header">
        <h3 className="bc-list__title">Visão anual de 2026</h3>
        <div className="bc-legend">
          <span><span className="bc-legend__sw" style={{ background: '#6FB68C' }} />Receitas</span>
          <span><span className="bc-legend__sw" style={{ background: '#EE9385' }} />Despesas</span>
        </div>
      </div>
      <div className="bc-annual__chart">
        <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
          {/* grid */}
          {[0.25, 0.5, 0.75, 1].map(t => (
            <line key={t} x1={PL} y1={yOf(max * t)} x2={W - PR} y2={yOf(max * t)}
              stroke="var(--sand-2)" strokeWidth="0.8" />
          ))}

          {/* expense line */}
          <polyline points={line('expense')} fill="none" stroke="#EE9385"
            strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />

          {/* income line */}
          <polyline points={line('income')} fill="none" stroke="#6FB68C"
            strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />

          {/* dots + labels */}
          {months.map((m, i) => (
            <g key={m.label}>
              <circle cx={xOf(i)} cy={yOf(m.income)}  r="3.5" fill="#6FB68C" />
              <circle cx={xOf(i)} cy={yOf(m.expense)} r="3.5" fill="#EE9385" />
              <text x={xOf(i)} y={H - 6} textAnchor="middle"
                fontSize="11" fontWeight="500" fill="var(--sand-6)"
                fontFamily="var(--font-ui)">
                {m.label}
              </text>
            </g>
          ))}
        </svg>
      </div>
    </div>
  )
}
